import Vue from "vue";
export default Vue.extend({
    props: {
        teamEmployees: [],
    },
    filters: {
        toPercentage(num) {
            return `${Math.round(num * 100)}%`;
        },
    },
    computed: {
        items() {
            if (!this.teamEmployees) {
                return [];
            }
            const test = this.teamEmployees.map((details) => {
                const foo = details.split(" | ");
                const target = {};
                foo.forEach((value, index) => {
                    target[`value${index + 1}`] = value;
                });
                return target;
            });
            return test;
        },
        headers() {
            //@ts-ignore
            return Object.keys(this.items[0]).map((header) => {
                return {
                    text: header,
                    value: header,
                };
            });
        },
    },
});
